import React from "react";
import {UserSecurityInfo} from "./UserSecurityInfo";
import {UserContentBase} from "./UserContentBase";


export class UserSecurityContent extends UserContentBase {
    render() {
        return (
            <section className="section-content">
                {this.renderHeaderAndTabs("third")}
                <div className="section-body h-items">
                    <UserSecurityInfo userId={this.props.userId}
                                      afterSuccessfulSubmit={this.handleAfterSuccessfulUserUpdated}
                    />
                </div>
            </section>
        )
    }
}
